import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBriefcase,
  IconBuildingFactory,
  IconBuildingWarehouse,
  IconCategory,
  IconFileExport,
  IconFolders,
  IconListDetails,
  IconPackage,
  IconRulerMeasure,
  IconSearch,
  IconTag,
  IconTimeDuration15,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { formatDateTime } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { DatePickerInput } from "@mantine/dates";
import { BASE_API_MDM } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReportInOutBalance = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}",
  );
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);

  const [search, setSearch] = useState<any>({
    FromDate: new Date(
      new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    ToDate: new Date(
      new Date(new Date(new Date()).setHours(0, 0, 0, 0)).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);
  const [serial, setSerial] = useDebouncedState<string>("", 300);
  const [itemCode, setItemCode] = useDebouncedState<string>("", 300);
  const [FromTuoiTonKho, setFromTuoiTonKho] = useDebouncedState("", 500);
  const [ToTuoiTonKho, setToTuoiTonKho] = useDebouncedState("", 500);

  const [selectIdBranch, setSelectIdBranch] = useState<string[]>([]);
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [dataInv, setDataInv] = useState<any[]>([]);
  const [dataBrand, setDataBrand] = useState<any[]>([]);

  const [dataCatSegment1a, setDataCatSegment1a] = useState<any[]>([]);
  const [dataCatSegment2bTemp, setDataCatSegment2bTemp] = useState<any[]>([]);
  const [dataCatSegment2b, setDataCatSegment2b] = useState<any[]>([]);
  const [dataCatSegment3cTemp, setDataCatSegment3cTemp] = useState<any[]>([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<any[]>([]);
  const [search4d, setSearch4d] = useState<string>("");
  const [debounceSearch4d] = useDebouncedValue<string>(search4d, 500);
  const [search5e, setSearch5e] = useState<string>("");
  const [debounceSearch5e] = useDebouncedValue<string>(search5e, 500);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<any[]>([]);
  const [dataCatSegment5e, setDataCatSegment5e] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      { accessorKey: "ma_Cn", header: "Mã chi nhánh" },
      { accessorKey: "ma_Kho", header: "Mã kho" },
      {
        accessorKey: "ma_Sp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="md"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue ?? "Không có mã sản phẩm"}
          </Badge>
        ),
      },
      {
        accessorKey: "serial",
        header: "Serial",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="md"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : "blue"}
          >
            {renderedCellValue ?? "Không có mã sản phẩm"}
          </Badge>
        ),
      },
      {
        accessorKey: "no_Serial",
        header: "Không serial",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text
              size="12.5px"
              fw={500}
              c={renderedCellValue === "Co_Serial" ? "teal" : "red"}
            >
              {renderedCellValue === "Co_Serial" ? "Có Serial" : "Không Serial"}
            </Text>
          ) : (
            <></>
          ),
      },
      { accessorKey: "ten_Sp", header: "Tên sản phẩm" },
      { accessorKey: "ma_Linh_Vuc", header: "Mã lĩnh vực" },
      { accessorKey: "ten_Linh_Vuc", header: "Tên lĩnh vực" },
      { accessorKey: "ma_Nganh", header: "Mã ngành" },
      { accessorKey: "ten_Nganh", header: "Tên ngành" },
      { accessorKey: "ma_Loai", header: "Mã loại" },
      { accessorKey: "ten_Loai", header: "Tên loại" },
      { accessorKey: "ma_Chung", header: "Mã chủng" },
      { accessorKey: "ten_Chung", header: "Tên chủng" },
      { accessorKey: "ma_Nhom", header: "Mã nhóm" },
      { accessorKey: "ten_Nhom", header: "Tên nhóm" },
      { accessorKey: "ma_Hang_Sx", header: "Mã hãng SX" },
      { accessorKey: "ten_Hang_Sx", header: "Tên hãng SX" },
      {
        accessorKey: "ngay_Nhap",
        header: "Ngày nhập",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTime(renderedCellValue)}
          </Text>
        ),
      },
      { accessorKey: "tuoi_Ton", header: "Tuổi tồn" },
      {
        accessorKey: "thang_Ton",
        header: "Tháng tồn",
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {getValueThangTon(String(renderedCellValue))}
          </Text>
        ),
      },
      { accessorKey: "slton_Dau", header: "Số lượng tồn đầu" },
      {
        accessorKey: "gtton_Dau",
        header: "Giá trị tồn đầu",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <Text size="12.5px" fw={500}>
              0 VNĐ
            </Text>
          ),
      },
      { accessorKey: "sl_Nhap", header: "Số lượng nhập" },
      {
        accessorKey: "gt_Nhap",
        header: "Giá trị nhập",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <Text size="12.5px" fw={500}>
              0 VNĐ
            </Text>
          ),
      },
      { accessorKey: "sl_Xuat", header: "Số lượng xuất" },
      {
        accessorKey: "gt_Xuat",
        header: "Giá trị xuất",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <Text size="12.5px" fw={500}>
              0 VNĐ
            </Text>
          ),
      },
      { accessorKey: "slton_Cuoi", header: "Số lượng tồn cuối" },
      {
        accessorKey: "gtton_Cuoi",
        header: "Giá trị tồn cuối",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <Text size="12.5px" fw={500}>
              0 VNĐ
            </Text>
          ),
      },
    ],
    [],
  );

  const getValueThangTon = (value: string) => {
    switch (value) {
      case "Ton1-3":
        return "Tồn 1 đến 3 tháng";
      case "Ton3-6":
        return "Tồn 3 đến 6 tháng";
      case "Ton6-9":
        return "Tồn 6 đến 9 tháng";
      case "Ton9-12":
        return "Tồn 9 đến 12 tháng";
      case "Ton1Nam-2Nam":
        return "Tồn 1 đến 2 năm";
      case "Khong_Ngay_Nhap":
        return "Không có ngày nhập";
      default:
        return value;
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/InventorySerialOnhand/get-list-in-out-balance?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0 && value.length === 1) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        } else if (Array.isArray(value) && value.length > 1) {
          params.append(key, value.map((item) => String(item)).join(","));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (serial.length > 0) {
        url += `&Serial=${serial}`;
      }

      if (itemCode.length > 0) {
        url += `&ItemCodes=${itemCode}`;
      }

      if (FromTuoiTonKho && FromTuoiTonKho?.length > 0) {
        url += `&FromTuoiTon=${FromTuoiTonKho}`;
      }

      if (ToTuoiTonKho && ToTuoiTonKho?.length > 0) {
        url += `&ToTuoiTon=${ToTuoiTonKho}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
        setIsCallFirst(true);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleExportExcel = async () => {
    open();
    try {
      let url = `/api/v1/ExportExcel/export-excel-report-in-out-balance?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0 && value.length === 1) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        } else if (Array.isArray(value) && value.length > 1) {
          params.append(key, value.map((item) => String(item)).join(","));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (serial.length > 0) {
        url += `&Serial=${serial}`;
      }

      if (itemCode.length > 0) {
        url += `&ItemCodes=${itemCode}`;
      }

      if (FromTuoiTonKho && FromTuoiTonKho?.length > 0) {
        url += `&FromTuoiTon=${FromTuoiTonKho}`;
      }

      if (ToTuoiTonKho && ToTuoiTonKho?.length > 0) {
        url += `&ToTuoiTon=${ToTuoiTonKho}`;
      }

      url += `&${params.toString()}`;

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_tuoi_ton" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };
  const handleExportExcelSLLon = async () => {
    open();
    try {
      let url = `/api/v1/ExportExcel/export-excel-report-in-out-balance-new?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0 && value.length === 1) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        } else if (Array.isArray(value) && value.length > 1) {
          params.append(key, value.map((item) => String(item)).join(","));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (serial.length > 0) {
        url += `&Serial=${serial}`;
      }

      if (itemCode.length > 0) {
        url += `&ItemCodes=${itemCode}`;
      }

      if (FromTuoiTonKho && FromTuoiTonKho?.length > 0) {
        url += `&FromTuoiTon=${FromTuoiTonKho}`;
      }

      if (ToTuoiTonKho && ToTuoiTonKho?.length > 0) {
        url += `&ToTuoiTon=${ToTuoiTonKho}`;
      }

      url += `&${params.toString()}`;

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });
      if (response.ok) {
        close();
        setTimeout(() => {
          NotificationExtension.Success(
            "Yêu cầu export đã được thêm vào hàng đợi. Vui lòng chờ trong giây lát!",
          );
        }, 3000);
      } else {
        setTimeout(() => {
          NotificationExtension.Fails("Export Excel thất bại !");
        }, 3000);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.value && item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
          id: item.value?.toString(),
        }));
      setDataBranch(data);
      changeSearchValue(
        [
          String(
            getValueById(String(userLoginHeader?.branchId), data, "value"),
          ),
        ],
        "BranchCodes",
        setSearch,
      );
    }
  };

  const fetchDataInv = async () => {
    const dataBranchSearch = selectIdBranch
      .map((item) => `&BranchId=${item}`)
      .join("");

    let url = "";

    if (selectIdBranch.length > 0) {
      url =
        `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${
          Number(selectIdBranch.length) * 50
        }` + dataBranchSearch;
    } else {
      url = `/api/v1/TblDmInventory/get-all`;
    }

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      if (selectIdBranch.length > 0) {
        const data = result
          ?.filter((item: any) => item.code && item.name)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
          }));
        setDataInv(data);
      } else {
        const data = result
          ?.filter((item: any) => item.name && item.code)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
          }));
        setDataInv(data);
      }
    }
  };

  const fetchDataBrand = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmBrand/get-all",
    );

    if (res && res?.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.text !== null && item.att1 !== null)
        ?.map((item: any) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
        }));
      setDataBrand(dataAPI);
    }
  };

  const fetchDataCatSegment1a = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment1a/get-all",
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment1a(data);
    }
  };

  const fetchDataCatSegment2b = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment2b/get-all",
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      data = res.data
        ?.filter(
          (item: any) =>
            item.codeString && item.name && item.segment1CodeString,
        )
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
          segment1CodeString: item.segment1CodeString?.toString(),
        }));

      setDataCatSegment2bTemp(data);
      setDataCatSegment2b(data);
    }
  };

  const fetchDataCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      data = res.data
        ?.filter(
          (item: any) =>
            item.codeString && item.name && item.segment2CodeString,
        )
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
          segment2CodeString: item.segment2CodeString?.toString(),
        }));

      setDataCatSegment3cTemp(data);
      setDataCatSegment3c(data);
    }
  };

  const getCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;

    if (search?.DsMaLoai && search?.DsMaLoai?.length > 0) {
      url += search?.DsMaLoai?.map(
        (item: any) => `&listCodeSegmentString3=${item}`,
      ).join("");
    }

    if (debounceSearch4d.length > 3) {
      url += `&KeySearch=${debounceSearch4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment4d(data);
    }
  };

  const getCatSegment5e = async () => {
    let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;

    if (search?.DsMaChung && search?.DsMaChung?.length > 0) {
      url += `&ListCodeString4=${search?.DsMaChung?.join(",")}`;
    }

    if (debounceSearch5e.length > 3) {
      url += `&KeySearch=${debounceSearch5e}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment5e(data);
    }
  };

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem(
        "reportInOutBalanceColumnPinning",
      );
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : {
            left: ["mrt-row-select", "mrt-row-numbers"],
          }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return {
        left: ["mrt-row-select", "mrt-row-numbers"],
      };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem(
        "reportInOutBalanceColumnPinning",
        JSON.stringify(columnPinning),
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([
      fetchDataBranch(),
      fetchDataCatSegment1a(),
      fetchDataCatSegment2b(),
      fetchDataCatSegment3c(),
      fetchDataBrand(),
    ]);
  }, []);

  useEffect(() => {
    getCatSegment4d();
  }, [debounceSearch4d, search?.DsMaLoai]);

  useEffect(() => {
    getCatSegment5e();
  }, [debounceSearch5e, search?.DsMaChung]);

  useEffect(() => {
    if (search?.DsMaLinhVuc && search?.DsMaLinhVuc?.length > 0) {
      const data = dataCatSegment2bTemp?.filter((item) =>
        search?.DsMaLinhVuc?.includes(item.segment1CodeString),
      );
      setDataCatSegment2b(data);
    } else {
      setDataCatSegment2b(dataCatSegment2bTemp);
    }
  }, [search?.DsMaLinhVuc]);

  useEffect(() => {
    if (search?.DsMaNganh && search?.DsMaNganh?.length > 0) {
      const data = dataCatSegment3cTemp?.filter((item) =>
        search?.DsMaNganh?.includes(item.segment2CodeString),
      );
      setDataCatSegment3c(data);
    } else {
      setDataCatSegment3c(dataCatSegment3cTemp);
    }
  }, [search?.DsMaNganh]);

  useEffect(() => {
    if (search?.BranchCodes && search?.BranchCodes.length > 0) {
      const dataId = dataBranch
        ?.filter((item) => search?.BranchCodes?.includes(item.value))
        ?.map((item) => item.id);

      setSelectIdBranch(dataId);
    } else {
      setSelectIdBranch([]);
    }
  }, [search?.BranchCodes]);

  useEffect(() => {
    fetchDataInv();
  }, [selectIdBranch]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (180 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: setColumnPinning,
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex direction={"row"} gap={10}>
            <Button
              leftSection={<IconFileExport size={14} />}
              onClick={() => handleExportExcel()}
            >
              Export Excel
            </Button>
            <Button
              leftSection={<IconFileExport size={14} />}
              onClick={() => handleExportExcelSLLon()}
            >
              Export Excel SL lớn
            </Button>
          </Flex>
        </Flex>
        <Grid w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              maxDate={
                search?.ToDate && search?.ToDate?.length > 0
                  ? new Date(search?.ToDate)
                  : new Date()
              }
              value={
                search?.FromDate && search?.FromDate?.length > 0
                  ? new Date(search?.FromDate)
                  : null
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch,
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              minDate={
                search?.FromDate && search?.FromDate?.length > 0
                  ? new Date(search?.FromDate)
                  : new Date()
              }
              maxDate={new Date()}
              value={
                search?.ToDate && search?.ToDate?.length > 0
                  ? new Date(search?.ToDate)
                  : null
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch,
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập serial"
              defaultValue={serial}
              onChange={(e) => setSerial(e.currentTarget.value)}
              leftSection={<IconBarcode color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập mã sản phẩm"
              defaultValue={itemCode}
              onChange={(e) => setItemCode(e.currentTarget.value)}
              leftSection={<IconTag color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Chi nhánh"
              data={dataBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={search?.BranchCodes}
              searchable
              clearable
              leftSection={<IconBrandBootstrap size={20} color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "BranchCodes", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              data={dataInv}
              value={search?.SubInvCodes}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "SubInvCodes", setSearch);
              }}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã lĩnh vực"
              data={dataCatSegment1a}
              leftSection={<IconCategory color="#15aabf" />}
              value={search?.DsMaLinhVuc}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "DsMaLinhVuc", setSearch)
              }
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã ngành"
              data={dataCatSegment2b?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              leftSection={<IconBriefcase color="#15aabf" />}
              searchable
              clearable
              value={search?.DsMaNganh}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "DsMaNganh", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã loại"
              data={dataCatSegment3c?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              leftSection={<IconPackage color="#15aabf" />}
              searchable
              clearable
              value={search?.DsMaLoai}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "DsMaLoai", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã chủng"
              data={dataCatSegment4d}
              leftSection={<IconListDetails color="#15aabf" />}
              searchable
              searchValue={search4d}
              onSearchChange={setSearch4d}
              clearable
              value={search?.DsMaChung}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "DsMaChung", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã nhóm"
              data={dataCatSegment5e}
              leftSection={<IconFolders color="#15aabf" />}
              searchable
              searchValue={search5e}
              onSearchChange={setSearch5e}
              clearable
              value={search?.DsMaNhom}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "DsMaNhom", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã hoặc tên hãng sản xuất"
              data={dataBrand}
              value={search?.DsMaHangSx}
              leftSection={<IconBuildingFactory color="#15aabf" />}
              searchable
              clearable
              onChange={(e) => {
                changeSearchValue(e ? e : [], "DsMaHangSx", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              type="number"
              placeholder="Tuổi tồn (Bắt đầu)"
              leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
              defaultValue={FromTuoiTonKho}
              onChange={(e) => setFromTuoiTonKho(e.target.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Tuổi tồn (Kết thúc)"
              leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
              defaultValue={ToTuoiTonKho}
              onChange={(e) => setToTuoiTonKho(e.target.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ReportInOutBalance;
